import { Icon, LoadingSkeleton } from '@joor/design-system'
import styled from 'styled-components/macro'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
`

const SkeletonContainer = styled.div`
  width: 100%;
`

const StyledIcon = styled(Icon)`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 32px;
  min-width: 32px;
  border-radius: 50%;
  border: 1px solid var(--color-primary-200);
  color: var(--color-primary-200);
`

export const LoadingContacts = () => (
  <Container>
    <Row>
      <StyledIcon iconName="person" variant="DISABLED" />
      <SkeletonContainer>
        <LoadingSkeleton width="56%" />
        <LoadingSkeleton />
      </SkeletonContainer>
    </Row>
    <Row>
      <StyledIcon iconName="person" variant="DISABLED" />
      <SkeletonContainer>
        <LoadingSkeleton width="56%" />
        <LoadingSkeleton />
      </SkeletonContainer>
    </Row>
  </Container>
)
